import React, { memo, useEffect, useState, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AutoSizer from "react-virtualized-auto-sizer";
import clsx from 'clsx';

import { HighlightSpan } from '../PriceBoardTotalMode';

import { priceToNumber, formatNumber, roundNumber } from '../../helpers/utils';

export default memo(function IndustryTop(props) {
    const { industryCode, symbolOnTop } = props;
    //
    const { t } = useTranslation();

    //
    const numberStockTop = useSelector(state => state.gShared.numberStockTop);

    const symbolsByIndustry = useSelector(state => state.gShared.industries.find(e => e.code === industryCode)?.symbolList);

    const { symbolInfos } =  useSelector(state => ({
        symbolInfos: state.gSymbol.symbolInfos.filter(e => symbolsByIndustry && symbolsByIndustry.indexOf(e.code) >= 0),
        checkFlag: state.gSymbol.symbolInfos.filter(e => symbolsByIndustry && symbolsByIndustry.indexOf(e.code) >= 0)?.length,
    }), (left, right) => {
        return left.checkFlag === right.checkFlag;
    });
    //
    const [markGetData, setMarkGetData] = useState(0);
    const [tabActive, setTabActive] = useState(0);

    //
    const symbolFiltered = useMemo(() => {
        let _symbolInfos = [];
        //
        if(symbolInfos) {
            if(tabActive == 0) {
                _symbolInfos = symbolInfos.filter(e => priceToNumber(e.changePrice) > 0).sort((a, b) => priceToNumber(b.changePrice) - priceToNumber(a.changePrice) || a.code.localeCompare(b.code));
            }
            else if(tabActive == 1) {
                _symbolInfos = symbolInfos.filter(e => 0 > priceToNumber(e.changePrice)).sort((a, b) => priceToNumber(a.changePrice) - priceToNumber(b.changePrice) || a.code.localeCompare(b.code));
            }
            else if(tabActive == 2) {
                _symbolInfos = symbolInfos.filter(e => priceToNumber(e.totalTradedQttyNM) > 0).sort((a, b) => priceToNumber(b.totalTradedQttyNM) - priceToNumber(a.totalTradedQttyNM) || a.code.localeCompare(b.code));
            }
            else if(tabActive == 3) {
                _symbolInfos = symbolInfos.filter(e => priceToNumber(e.totalTradedValueNM) > 0).sort((a, b) => priceToNumber(b.totalTradedValueNM) - priceToNumber(a.totalTradedValueNM) || a.code.localeCompare(b.code));
            }
            else if(tabActive == 4) {
                _symbolInfos = symbolInfos.filter(e => priceToNumber(e.subForeignValue) > 0).sort((a, b) => priceToNumber(b.subForeignValue) - priceToNumber(a.subForeignValue) || a.code.localeCompare(b.code));
            }
            else if(tabActive == 5) {
                _symbolInfos = symbolInfos.filter(e => priceToNumber(e.subForeignValue) < 0).sort((a, b) => priceToNumber(a.subForeignValue) - priceToNumber(b.subForeignValue) || a.code.localeCompare(b.code));
            }

            //
            const _sumData = _symbolInfos?.reduce(function (prevValue, currValue) {
                return { 
                    totalTradedQttyNM: prevValue.totalTradedQttyNM + priceToNumber(currValue.totalTradedQttyNM),
                    totalTradedValueNM: prevValue.totalTradedValueNM + priceToNumber(currValue.totalTradedValueNM)
                };
            }, {totalTradedQttyNM: 0, totalTradedValueNM: 0}), _totalTradedQttyNM = _sumData?.totalTradedQttyNM ?? 0, _totalTradedValueNM = _sumData?.totalTradedValueNM ?? 0;

            _symbolInfos = _symbolInfos?.slice(0, numberStockTop);
            
            if(_symbolInfos && _symbolInfos.length > 0) {
                _symbolInfos.map((item, idx) => {
                    item.position = idx + 1;
                    item.positionOrder = 1;

                    item.indQttyWeight = _totalTradedQttyNM > 0 ? roundNumber(priceToNumber(item.totalTradedQttyNM) / _totalTradedQttyNM * 100, 2) : null;
                    item.indValueWeight = _totalTradedValueNM > 0 ? roundNumber(priceToNumber(item.totalTradedValueNM) / _totalTradedValueNM * 100, 2) : null;

                    if(item.code === symbolOnTop) {
                        item.positionOrder = 0; 
                    }
                });

                _symbolInfos = _symbolInfos.sort((a, b) => a.positionOrder - b.positionOrder || a.position - b.position);
            }
        }
        return _symbolInfos;
    }, [tabActive, markGetData, numberStockTop])

    //
    useEffect(() => {
        const _intervalId = setInterval(() => {
            setMarkGetData(markGetData => markGetData + 1);
        }, 10000);
        return () => {
            clearInterval(_intervalId);
        }
    }, [])

    //
    return (
        <>
            {
                industryCode && industryCode !== "" ? (
                    <div className="d-flex flex-column h-100">
                        <div className="btn__nn btn__spacing">
                            <button className={tabActive === 0 ? "active" : ""} onClick={()=> setTabActive(0)}>{t("topTang")}</button>
                            <button className={tabActive === 1 ? "active" : ""} onClick={()=> setTabActive(1)}>{t("topGiam")}</button>
                            <button className={tabActive === 2 ? "active" : ""} onClick={()=> setTabActive(2)}>{t("topKLGD")}</button>
                            <button className={tabActive === 3 ? "active" : ""} onClick={()=> setTabActive(3)}>{t("topGTGD")}</button>
                            <button className={tabActive === 4 ? "active" : ""} onClick={()=> setTabActive(4)}>{t("topNNMua")}</button>
                            <button className={tabActive === 5 ? "active" : ""} onClick={()=> setTabActive(5)}>{t("topNNBan")}</button>
                        </div>
                        <div className="tbl__popup" style={{flex: 1}}>
                            <AutoSizer>
                                {({ height, width }) => {
                                    return (
                                        <div style={{height: height, width: width}}>
                                            <div className="scroll-styled">
                                                <table className="tb-sticky sticky-left" style={{whiteSpace: "nowrap"}}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">{t('stt')}</th>
                                                            <th className="text-left">{t('maCK')}</th>
                                                            <th className="text-right">{t('tc')}</th>
                                                            <th className="text-right">{t('giaKhop')}</th>
                                                            <th className="text-right">+/-</th>
                                                            <th className="text-right">%</th>
                                                            {tabActive !== 4 && tabActive !== 5 ? (
                                                                <>
                                                                <th className="text-right" style={{width: '11%'}}>{t('tongKLKhop')}</th>
                                                                <th className="text-right" style={{width: '11%'}}>{t('tongGTKhop')}</th>
                                                                <th className="text-right" style={{width: '11%'}}>{t('tyTrongTongKL')}</th>
                                                                <th className="text-right" style={{width: '11%'}}>{t('tyTrongTongGT')}</th>
                                                                </>
                                                            ) : null}
                                                            <th className="text-right" style={{width: '11%'}}>{t('klNNMua')}</th>
                                                            <th className="text-right" style={{width: '11%'}}>{t('klNNBan')}</th>
                                                            {tabActive && (tabActive === 4 || tabActive === 5) ? (
                                                                <>
                                                                <th className="text-right" style={{width: '11%'}}>{t('klNNRong')}</th>
                                                                <th className="text-right" style={{width: '11%'}}>{t('gtNNMua')}</th>
                                                                <th className="text-right" style={{width: '11%'}}>{t('gtNNBan')}</th>
                                                                <th className="text-right" style={{width: '11%'}}>{t('gtNNRong')}</th>
                                                                </>
                                                            ) : null}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            symbolFiltered && symbolFiltered.map((el, index ) => {
                                                                return (
                                                                    <IndustryTopRow key={index} code={el.code} tabActive={tabActive} />
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )
                                }}
                            </AutoSizer>
                        </div>
                    </div>
                ): null
            }
        </>
    )
}, (prevProps, nextProps) => {
    if (prevProps.industryCode === nextProps.industryCode && prevProps.symbolOnTop === nextProps.symbolOnTop) {
        return true;
    }
    return false;
})

//
const IndustryTopRow = memo((props) => {

    const { code, tabActive } = props;

    const _refHighlightFlag = useRef("");
    const _fireEvent = _refHighlightFlag.current === code + "|" + tabActive;

    const el_counter = useSelector(state => state.gSymbol.symbolInfos.find(e => e.code === code)?.counter);
    const el = useSelector(state => state.gSymbol.symbolInfos.find(e => e.code === code));

    //
    useEffect(() => {
        _refHighlightFlag.current = code + "|" + tabActive;
    }, [code, tabActive]);

    //
    return (
        <tr>
            <td className="text-center">{el.position}</td>
            <td className="text-left"><HighlightSpan id={el.code + "_idt_code"} value={el.code} fireEvent={false} /></td>
            <td className="text-right clr-ref"><HighlightSpan id={el.code + "_idt_refPrice"} value={el.refPrice} fireEvent={false} /></td>
            <td className={clsx("text-right", el.matchPrice_color)}><HighlightSpan id={el.code + "_idt_matchPrice"} value={el.matchPrice} fireEvent={_fireEvent} /></td>
            <td className={clsx("text-right", el.matchPrice_color)}><HighlightSpan id={el.code + "_idt_changePrice"} value={el.changePrice} fireEvent={_fireEvent} /></td>
            <td className={clsx("text-right", el.matchPrice_color)}><HighlightSpan id={el.code + "_idt_pctChangePrice"} value={el.pctChangePrice} fireEvent={_fireEvent} /></td>
            {tabActive !== 4 && tabActive !== 5 ? (
                <>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_totalTradedQttyNM"} value={formatNumber(el.totalTradedQttyNM)} fireEvent={_fireEvent} /></td>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_totalTradedValueNM"} value={formatNumber(el.totalTradedValueNM)} fireEvent={_fireEvent} /></td>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_indQttyWeight"} value={el.indQttyWeight ? el.indQttyWeight + '%' : ''} fireEvent={false} /></td>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_indValueWeight"} value={el.indValueWeight ? el.indValueWeight + '%' : ''} fireEvent={false} /></td>
                </>
            ) : null}
            <td className="text-right"><HighlightSpan id={el.code + "_idt_buyForeignQtty"} value={formatNumber(el.buyForeignQtty)} fireEvent={_fireEvent} /></td>
            <td className="text-right"><HighlightSpan id={el.code + "_idt_sellForeignQtty"} value={formatNumber(el.sellForeignQtty)} fireEvent={_fireEvent} /></td>
            {tabActive && (tabActive === 4 || tabActive === 5) ? (
                <>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_subForeignQtty"} value={formatNumber(el.subForeignQtty)} fireEvent={_fireEvent} /></td>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_buyForeignValue"} value={formatNumber(el.buyForeignValue)} fireEvent={_fireEvent} /></td>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_sellForeignValue"} value={formatNumber(el.sellForeignValue)} fireEvent={_fireEvent} /></td>
                <td className="text-right"><HighlightSpan id={el.code + "_idt_subForeignValue"} value={formatNumber(el.subForeignValue)} fireEvent={_fireEvent} /></td>
                </>
            ) : null}
        </tr>
    )
}, (prevProps, nextProps) => {
    if (prevProps.code === nextProps.code && prevProps.tabActive === nextProps.tabActive) {
        return true;
    }
    return false;
});